import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import classes from "./PrivacyPolicy.module.css";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Privacy And Cookie Policy - How Server Stock UK Protects Your Personal
          Data
        </title>
        <meta
          name="description"
          content="At Server Stock UK, your privacy matters. Learn how we securely collect, use, and protect customer information while shopping for IT hardware online."
        />
        <link
          rel="canonical"
          href="https://www.serverstock.co.uk/privacy-policy"
        />
      </Helmet>

      <Breadcrumb currentPage="Privacy And Cookie Policy" />
      <div className={`container ${classes.privacyPolicyContainer}`}>
        <p className={classes.paragraph}>
          Our privacy policy Clarifies the procedures by which Server Stock
          utilizes and ensures the security of any information you furnish
          during your interactions with us, whether through this website or
          alternative methods like phone, email, or written communication.
          Ensuring the security of your privacy remains our utmost priority. Any
          personal information requested from you during your website
          interactions will be used strictly in adherence to our privacy policy
          Kindly note that Server Stock retains the right to revise its privacy
          policy. We suggest periodically reviewing this page to confirm your
          agreement with our policies. Your use of our site and services implies
          your acceptance of our privacy policy. Furthermore, you grant consent
          to Server Stock for the storage, processing, and sharing of your
          information, as specified in our privacy policy. If you disagree with
          these policies, we kindly ask you to refrain from using this site.
          Carefully review our Privacy Policy to gain a thorough understanding
          of how we process your data to enhance our service.
        </p>
        <h2 className={classes.subheading}>Who Are We?</h2>
        <p className={classes.paragraph}>
          Server Stock is dedicated to providing a dependable platform to
          fulfill your hardware requirements. Our office is located at F-10 Leaf
          House, Catherine Place, Harrow, HA1 2J, with the company number
          15092277. You can contact us via phone at{" "}
          <Link to="tel:+442475420877">+44 247 542 0877</Link> or through email
          at{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
          If you have any inquiries or concerns regarding the protection and
          security of your data, please don't hesitate to reach out to us
          directly at{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
          .
        </p>

        <h2 className={classes.subheading}>Information We Collect:</h2>
        <p className={classes.paragraph}>
          The data we collect from our customers serves the primary purpose of
          order processing while also contributing to the improvement of our
          service quality. This information is utilized to provide customers
          with relevant details, order confirmations, and status updates.
          Additionally, it helps keep customers informed about our products,
          services, and those offered by our affiliates. The collected data
          includes customer names, billing and shipping addresses, telephone and
          fax numbers, email addresses, and payment information (such as credit
          card details for order processing). Our aim in gathering this data is
          to gain insights into the shopping experiences and buying habits of
          our customers, ultimately enhancing our services and delivering an
          improved shopping experience.
        </p>

        <h2 className={classes.subheading}>Registration:</h2>
        <p className={classes.paragraph}>
          To initiate the processing of your orders, You may have to register
          with us. Throughout the registration process, you will be prompted to
          provide your contact details, your name, email address, telephone
          number, and address. This information will be utilized for the purpose
          of keeping you informed about the status of your orders through email
          updates.
        </p>

        <h2 className={classes.subheading}>Ordering:</h2>
        <p className={classes.paragraph}>
          While registering, we collect information essential for processing
          your orders, including credit card details, personal information and
          payment confirmation details. It's important to emphasize that we
          strictly use this information for billing purposes and to complete the
          order processing. Your financial details are not stored on our site
          but are shared with the merchant bank solely for authorization and
          approval. Rest assured, our robust security system is in place to
          safeguard this process, reflecting our deep commitment to ensuring the
          privacy and security of our valued customer.
        </p>

        <h2 className={classes.subheading}>Use of Cookies</h2>
        <p className={classes.paragraph}>
          We utilize cookies to elevate your experience on our website. By
          gathering information about you, we personalize specific pages and
          services to better suit your needs. Cookies play a vital role in
          analyzing and enhancing our services, as well as detecting fraud. They
          empower us to identify your browser throughout your visit and display
          the items in your shopping cart. Customers have the option to disable
          cookies in their browser, we highly recommend enabling them to fully
          enjoy the special services available at{" "}
          <Link to="https://www.serverstock.co.uk">serverstock.co.uk</Link>. If
          you wish to disable cookies, please refer to the help function in your
          browser's toolbar to learn how to prevent the installation of new
          cookies or disable them completely.
        </p>

        <h2 className={classes.subheading}>
          Third Parties That May Access Your Information:
        </h2>
        <p className={classes.paragraph}>
          We collaborate with third-party companies to facilitate various
          functions, including shipping, order tracking, credit card processing,
          and postal and email delivery. This information is pivotal for
          ensuring the successful delivery of packages and contributes to data
          analysis, marketing, and order fulfillment — all essential elements in
          achieving our primary goal of delivering your order efficiently. While
          these third-party associates have restricted access to your personal
          information, we assure you that it will not be used for any other
          purpose. At our company, we consider customer information as one of
          our most valuable business assets and commit to using your personal
          information strictly within the guidelines outlined in our Privacy
          Policy. Your safety and privacy are our top priorities, and we are
          devoted to providing you with the finest shopping experience possible.
        </p>

        <h2 className={classes.subheading}>Linking to External Sites:</h2>
        <p className={classes.paragraph}>
          The website may feature numerous links directing to third-party
          websites or applications. These external sites and applications may
          gather information about you. We encourage you to be mindful of this
          when leaving our site and recommend reviewing the privacy statements
          of each application and website you encounter. This privacy policy
          pertains to information collected by serverstock.co.uk; therefore, any
          linked websites or applications you visit are not owned by us. The
          website may feature links redirecting you to other third-party
          websites or applications, which may collect information about you.
          Consequently, we strongly advise exercising caution when navigating
          away from our website and recommend reviewing the privacy policies of
          every website and application you encounter. Please note that our
          privacy policy exclusively applies to information collected by
          serverstock.co.uk. We neither own nor operate any linked websites or
          applications and bear no responsibility for their policies and
          practices.
        </p>

        <h2 className={classes.subheading}>
          Make Use of a Security-Enabled Browser:
        </h2>
        <p className={classes.paragraph}>
          Security-enabled web browsers can optimize your browsing experience
          while ensuring the highest level of data security. Conversely, an
          insecure web browser may result in the installation of false apps or
          viruses on your computer without acknowledgment. Attackers can exploit
          this vulnerability to take control of your computer or even steal your
          information, which they can then use to launch attacks on other
          computers.
        </p>

        <h2 className={classes.subheading}>When You Volunteer Information:</h2>
        <p className={classes.paragraph}>
          By offering feedback or volunteer information on our website, such as
          through reviews, forums, or chat files, you agree to the partial
          disclosure of certain aspects of your personal information. We utilize
          this personal information to generate original content for our site,
          allowing other users to benefit from your positive experiences with
          Server Stock. Rest assured that your opinions, reviews, and feedback
          will be maintained in their genuine and unaltered form, preserving
          their intended meaning.
        </p>

        <h2 className={classes.subheading}>You Are Free to Opt-Out:</h2>
        <p className={classes.paragraph}>
          When opting to share information or engage in the feedback section of
          the site, including reviews, opinions, forums, chat files, or other
          forms of public communication, please be mindful that certain elements
          of your personal information may be disclosed to some extent. By
          contributing feedback or sharing information on our website, you
          consent to us utilizing your personal details to generate original
          content for the site, aiding other users in benefiting from your
          positive experiences with Server Stock. We assure you that your
          opinions, reviews, and feedback will be preserved in their genuine and
          unaltered form.
        </p>
      </div>
    </>
  );
}
